import { render, staticRenderFns } from "./PerPage.vue?vue&type=template&id=678d5808"
import script from "./PerPage.vue?vue&type=script&lang=ts"
export * from "./PerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports